import { SiteUrls } from '@tableau/shared-urls';
import { OmniboxV2ViewModel } from '../viewModels/OmniboxV2ViewModel';

export type NavigationItemValueType = MenuItemHeaderInfo | 'searchBox';

export type OmniboxMenuItemPlaceholder = { id: string, type: OmniBoxItemType };

export enum OmniBoxItemType {
  databases = 'databases',
  dataRoles = 'dataRoles',
  datasources = 'datasources',
  flows = 'flows',
  global = 'global',
  lenses = 'lenses',
  metrics = 'metrics',
  projects = 'projects',
  virtualConnections = 'virtualConnections',
  tables = 'tables',
  views = 'views',
  workbooks = 'workbooks',
  searchbox = 'searchBox',
  sectionHeader = 'sectionHeader',
  placeholder = 'placeholder',
  collections = 'collections',
  searchTermItem = 'searchTermItem',
  pastQueryItem = 'pastQueryItem',
  contentSuggestionItem = 'contentSuggestionItem',
  contentTypeItem = 'contentTypeItem',
  ownerItem = 'ownerItem'
}

export type NavigationItem = {
  sectionIndex: number;
  itemIndex: number;
  type: OmniBoxItemType;
  target: NavigationItemValueType;
  left: NavigationItemValueType | null;
  right: NavigationItemValueType | null;
  up: NavigationItemValueType | null;
  down: NavigationItemValueType | null;
  total: number;
  contentId?: string;
  countInSection: number;
  countInRow: number;
}

export interface MenuItemHeaderInfo {
  headerType: OmniBoxItemType;
}

export interface Section {
  type: OmniBoxItemType;
}

export interface CatalogOmniboxItem {
  readonly id: string;
  readonly name: string;
  readonly isCertified: boolean;
  readonly workbookCount: number;
  readonly datasourceCount: number;
}

export interface IQuickLinksContentTypes {
  name: string;
  getPath: (urls: SiteUrls) => string;
  icon: string;
}

export enum ContentType {
  view = 'view',
  metric = 'metric',
  workbook = 'workbook',
  unifieddatasource = 'unifieddatasource',
  virtualconnection = 'virtualconnection',
  flow = 'flow',
  project = 'project',
  table = 'table',
  database = 'database',
  datarole = 'datarole',
  lens = 'lens',
  collection = 'collection',
}

export type ContentSuggestionData = {
  hits: {
    items: ContentSuggestionDataItem[];
  };
};

export type ContentSuggestionDataItem = {
  content: {
    id: number;
    luid?: string;
    title?: string;
    type: string;
    ownerName?: string;
    hitsMediumSpanTotal?: number;
    graphQLId?: string;
    isCertified?: boolean;
    hasActiveDataQualityWarning?: boolean;
    hasSevereDataQualityWarning?: boolean;
    datasourceId?: number;
    modifiedTime?: string;
    itemCount?: number;
    connectedWorkbooksCount?: number;
    path?: string;
    connectionType?: string;
  };
  highlights?: {
    title?: string[];
    owner?: string[];
  };
}

export type OmniboxConfiguration = {
  apiHost?: string;
  showOwnerLinks?: boolean;
  contentTypesForQuickLinks?: ContentType[];
  onExecutingSearch?(searchTerm: string): void;
  onContentSuggestionItemClicked?(contentType: ContentType, data: ContentSuggestionDataItem): void;
  onContentTypeLinkClicked?(contentType: ContentType): void;
  onOwnerLinkClicked?(ownerId: string): void;
  searchPlaceHolderText?: string;
  requiredContentTypes?: ContentType[];
  hostComponent?: string;
  pastQueryMaxCount?: number;
  contentSuggestionMaxCount?: number;
  emptyStateContentSuggestionMaxCount?: number;
  xsrfToken?: string;
  onViewModelReady?: (viewModel: OmniboxV2ViewModel) => void;
  shouldShowSuggestion?: (type: string, connectionType: string, id: string) => Promise<boolean>;
  emptyStateContentSuggestionFetchLimit?: number;
}